"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomerAccountEdit = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackCustomerAccountEdit(eventLabel) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory: 'CustomerAccount',
        eventAction: 'Edit',
        eventLabel,
        nonInteraction: false,
    });
}
exports.trackCustomerAccountEdit = trackCustomerAccountEdit;
//# sourceMappingURL=trackCustomerAccountEdit.js.map